import ComponentBase from './base';
import { 
    setExpandedCls,
    setCollapsedCls,
} from '../utils';

class ComponentExpander extends ComponentBase {
    constructor ({ 
        /** Base component prams */         
        id,
        el,
        html,
        handler,
        handlers,
        destroyWithEl,
        childCmps,
        keepedCmps,
        data,
        onReadyFns,
        type,
        rootElement,
        disabled,
        initConfig,
        /** Expander component params */  
        expanded
    }) {
        super ({        
            id,
            el,
            html,
            handler,
            handlers,
            destroyWithEl,
            childCmps,
            keepedCmps,
            data,
            onReadyFns,
            type,
            rootElement,
            disabled,
            initConfig,
        });
        this.expanded = !!expanded;
    }
    keepedLabelCmp = null;
    keepedInfoCmp = null;
    keepedExpandBtnCmp = null;
    keepLabelCmp = function (cmp) {
        this.keepedLabelCmp = cmp;
    }
    getKeepedLabelCmp = function () {
        return this.keepedLabelCmp || null;
    }
    keepInfoCmp = function (cmp) {
        this.keepedInfoCmp = cmp;
    }
    getKeepedInfoCmp = function () {
        return this.keepedInfoCmp || null;
    }
    keepExpandBtnCmp = function (cmp) {
        this.keepedExpandBtnCmp = cmp;
    }
    getKeepedExpandBtnCmp = function () {
        return this.keepedExpandBtnCmp || null;
    }
    expand = function () {
        setExpandedCls(this.getEl());
        this.expanded = true;
        this.collapsed = false;
    }
    collapse = function () {
        setCollapsedCls(this.getEl());
        this.expanded = false;
        this.collapsed = true;
    }
    getExpanded =  function () {
        return this.expanded;
    }
    getCollapsed = function () {
        return this.collapse;
    }
}

export default ComponentExpander;